// extracted by mini-css-extract-plugin
export default {"gridContainer":"ReasonList_gridContainer__9AsLl"};